/**
 * Analytics configuration
 */
/**
 * Default configuration
 */
export const DEFAULT_CONFIG = {
    apiHost: "https://us.i.posthog.com",
    debug: false,
    disabled: false,
    capturePageview: true,
    capturePageleave: true,
};
/**
 * Merge user config with defaults
 */
export function mergeConfig(config) {
    return {
        ...DEFAULT_CONFIG,
        ...config,
    };
}
//# sourceMappingURL=config.js.map